import React, { useEffect, useRef, useState } from 'react';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js`;

const PDFViewer = ({ url, nomeUsuario = "USUÁRIO" }) => {
  const canvasRef = useRef(null);
  const thumbContainer = useRef(null);
  const [pdf, setPdf] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [thumbs, setThumbs] = useState([]);
  const isMobile = window.innerWidth <= 768; // simples e confiável para React puro


  useEffect(() => {
    const loadPDF = async () => {
      const loadingTask = getDocument(url);
      const loadedPdf = await loadingTask.promise;
      setPdf(loadedPdf);
      setNumPages(loadedPdf.numPages);

      // Gera miniaturas
      const thumbList = [];
      for (let i = 1; i <= loadedPdf.numPages; i++) {
        const page = await loadedPdf.getPage(i);
        const viewport = page.getViewport({ scale: 0.2 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;
        thumbList.push(canvas.toDataURL());
      }
      setThumbs(thumbList);
    };

    loadPDF();
  }, [url]);

  useEffect(() => {
    const renderPage = async () => {
      if (!pdf) return;
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: zoom });

      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      context.clearRect(0, 0, canvas.width, canvas.height);

      await page.render({ canvasContext: context, viewport }).promise;


// Marca d'água espalhada
const repeatX = 4;
const repeatY = 6;

context.font = 'bold 16px sans-serif';
context.fillStyle = 'rgba(0, 0, 0, 0.025)';
context.textAlign = 'center';

for (let i = 0; i < repeatX; i++) {
  for (let j = 0; j < repeatY; j++) {
    const x = (canvas.width / repeatX) * i + 50;
    const y = (canvas.height / repeatY) * j + 50;
    context.save();
    context.translate(x, y);
    context.rotate(-0.4); // inclinação diagonal
    context.fillText(nomeUsuario, 0, 0);
    context.restore();
  }
}

    };

    renderPage();

    // 🔁 Pré-carrega próxima página para fluidez
    if (pdf && pageNum < numPages) {
      pdf.getPage(pageNum + 1).then(() => {});
    }
  }, [pdf, pageNum, zoom, nomeUsuario, numPages]);

  const handleNext = () => {
    if (pageNum < numPages) setPageNum(pageNum + 1);
  };

  const handlePrev = () => {
    if (pageNum > 1) setPageNum(pageNum - 1);
  };

  const zoomIn = () => setZoom((z) => Math.min(z + 0.2, 3));
  const zoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.5));

return (
  <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', height: 'calc(100vh - 70px)' }}>
    
    {/* MINIATURAS - só no desktop */}
    {!isMobile && (
      <div
        ref={thumbContainer}
        style={{
          width: '90px',
          overflowY: 'auto',
          background: '#111',
          padding: '5px',
          borderRight: '1px solid #333'
        }}
      >
        {thumbs.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`p${idx + 1}`}
            onClick={() => setPageNum(idx + 1)}
            style={{
              width: '100%',
              marginBottom: 5,
              border: pageNum === idx + 1 ? '2px solid #00f' : '1px solid #444',
              cursor: 'pointer',
              borderRadius: 4,
            }}
          />
        ))}
      </div>
    )}

    {/* ÁREA PRINCIPAL */}
    <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? 10 : 20, textAlign: 'center' }}>
      <div style={{ marginBottom: 10 }}>
        <button onClick={handlePrev} disabled={pageNum <= 1} style={btn}>◀</button>
        <button onClick={handleNext} disabled={pageNum >= numPages} style={btn}>▶</button>
        <button onClick={zoomOut} style={btn}>➖</button>
        <button onClick={zoomIn} style={btn}>➕</button>
      </div>

<canvas
  ref={canvasRef}
  style={{
    transform: `scale(${zoom})`,
    transformOrigin: 'top center',
    maxWidth: '100%',
    borderRadius: 6,
    boxShadow: '0 0 6px #00000055'
  }}
/>



      <p style={{ color: '#888', marginTop: 10 }}>
        Página {pageNum} de {numPages}
      </p>
    </div>
  </div>
);

};

// Estilo de botão simples e moderno
const btn = {
  margin: '0 6px',
  padding: '8px 12px',
  borderRadius: '8px',
  background: '#1f2937',
  color: '#fff',
  border: 'none',
  fontWeight: 'bold',
  cursor: 'pointer',
  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
};

export default PDFViewer;
